import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

/**
 * Handles `/access/:password` deep links from invite emails. POSTs the password
 * to the auth endpoint, then forwards to the portfolio (replacing history so
 * the password never sits in the back-stack).
 */
export default function AccessRedirect() {
  const { access } = useParams<{ access: string }>();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (!access) {
      navigate('/welcome', { replace: true });
      return;
    }
    let cancelled = false;
    (async () => {
      const ok = await login(access);
      if (cancelled) return;
      navigate(ok ? '/' : '/welcome', { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [access, login, navigate]);

  return null;
}
